import React, { useState, useEffect } from 'react';

const CompanyModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Listener para abrir o modal quando clicado no link da empresa
    const handleOpenModal = () => setIsOpen(true);
    
    // Adicionar event listener global
    window.addEventListener('openCompanyModal', handleOpenModal);
    
    return () => {
      window.removeEventListener('openCompanyModal', handleOpenModal);
    };
  }, []);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-lg w-full p-6 animate-slide-up">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-secondary-900">Company Information</h2>
          <button
            onClick={() => setIsOpen(false)}
            className="text-secondary-400 hover:text-secondary-600 text-2xl leading-none"
          >
            ×
          </button>
        </div>
        
        <div className="space-y-4 text-secondary-700">
          <div>
            <h3 className="font-semibold text-secondary-900 mb-2">Registration Information</h3>
            <div className="space-y-1 text-sm">
              <p><strong>CNPJ:</strong> 53.542.960/0001-40</p>
              <p><strong>Company Name:</strong> M42 - Orion Assessoria LTDA</p>
              <p><strong>Opening Date:</strong> January 17, 2024</p>
              <p><strong>Legal Nature:</strong> Limited Liability Company</p>
              <p><strong>Status:</strong> Active</p>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold text-secondary-900 mb-2">Address</h3>
            <div className="text-sm">
              <p>Avenida Hilário Pereira de Souza, 492</p>
              <p>Sala 3003 Anexo Torre 2 Pavmto30</p>
              <p>Centro, Osasco - SP</p>
              <p>CEP: 06010-170</p>
            </div>
          </div>
          
          <div>
            <h3 className="font-semibold text-secondary-900 mb-2">Contact</h3>
            <div className="text-sm">
              <p><strong>E-mail:</strong> contato@bizrep.ai</p>
              <p><strong>Phone:</strong> (11) 98696-6006</p>
            </div>
          </div>
          
          <div className="pt-3 border-t border-secondary-200">
            <h3 className="font-semibold text-secondary-900 mb-2">About BIZREP</h3>
            <p className="text-sm text-secondary-600">
              BIZREP is an innovative solution developed by M42 Orion, offering business automation 
              with artificial intelligence, AI agents for customer service, and integrated traffic 
              management for businesses worldwide.
            </p>
          </div>
        </div>
        
        <div className="mt-6 flex justify-end">
          <button
            onClick={() => setIsOpen(false)}
            className="btn-primary"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyModal;

